Vue.use(window.VueInfiniteLoading)
new Vue({
    el: '#photoApp',
    data: function () {
        return {
            items: pApp.items,
            tags: pApp.tags,
            keyword: '',
            isModalOpen: false,
            selectedTags: [],
            start: 0,
            end: 12,
            page: 12,
            isTagsFix: false,
            observer: null,
        }
    },
    mounted: function () {
        var self = this
        var urlTags = self.convParamToObj()
        if (urlTags) {
            _.each(self.tags, function (tag, index) {
                if (urlTags.indexOf(tag.name) !== -1) {
                    tag.on = true
                    self.selectedTags.push(tag.name)
                    self.moveAt(self.tags, index, 0)
                }
            })
        }
        if (sessionStorage.start) {
            this.start = sessionStorage.start
        }
        if (sessionStorage.end) {
            this.end = sessionStorage.end
        }
        if (typeof IntersectionObserver === 'function') {
            // 後で操作する用に固定部分の要素を取得
            self.observer = new IntersectionObserver(function (entries) {
                _.each(entries, function (entry) {
                    // entry.isIntersectingはわずかでも画面に入っていればtrue
                    if (entry.isIntersecting) {
                        // 固定されていない場合の処理
                        self.isTagsFix = false
                    } else {
                        // 固定されている場合の処理
                        self.isTagsFix = true
                    }
                })
            })
            self.observer.observe(this.$refs.photoApp_header)
        }
    },
    computed: {
        filterdItems: function () {
            var self = this
            if (self.selectedTags.length > 0) {
                var _items = _.filter(self.items, function (o) {
                    return _.find(self.selectedTags, function (seleTag) {
                        return o.tags.indexOf(seleTag) != -1
                    })
                })
                return _items
            }
            return self.items.slice(0, this.end)
        },
        filterdTags: function () {
            var self = this
            if (self.keyword.length > 0) {
                var _tags = _.filter(self.tags, function (o) {
                    return o.name.indexOf(self.keyword) >= 0
                })
                return _tags
            } else {
                return self.tags
            }
        },
        // selectedTags2: function () {
        //     var self = this
        //     var _tags = _.filter(self.tags, function (o) {
        //         return o.on
        //     })
        //     return _tags
        // },
    },
    methods: {
        infiniteHandler: function ($state) {
            if (this.end > this.items.length) {
                // 表示するデータが無くなった場合
                $state.complete()
            } else {
                // 表示するデータがある場合
                sessionStorage.start = this.start = this.start + this.page
                sessionStorage.end = this.end = this.end + this.page
                $state.loaded()
            }
        },
        convParamToObj: function () {
            var search = location.hash.substring(1)
            if (search) {
                search = decodeURI(search)
                search = search.split(',')
                console.log('はい', search)
                return search
            }
            return false
        },
        changeselectedTags: function () {
            var self = this
            var hash = this.selectedTags.join(',')
            if (hash.length > 0) {
                history.replaceState(
                    null,
                    document.title,
                    window.location.pathname + '#'+hash
                )
            } else {
                history.replaceState(
                    null,
                    document.title,
                    window.location.pathname
                )
            }
        },
        modalOpen: function () {
            this.isModalOpen = true
        },
        modalClose: function () {
            this.isModalOpen = false
        },
        tagToggle: function (tag) {
            if (tag.on) {
                var index = this.selectedTags.indexOf(tag.name)
                this.selectedTags.splice(index, 1)
            } else {
                this.selectedTags.push(tag.name)
            }
            tag.on = !tag.on
            sessionStorage.start = this.start = 0
            sessionStorage.end = this.end = this.page
            this.$refs.InfiniteLoading.stateChanger.reset()
            this.changeselectedTags();
        },
        moveAt: function (array, index, at) {
            if (
                index === at ||
                index > array.length - 1 ||
                at > array.length - 1
            ) {
                return array
            }

            var value = array[index]
            var tail = array.slice(index + 1)

            array.splice(index)

            Array.prototype.push.apply(array, tail)

            array.splice(at, 0, value)

            return array
        },
    },
})

var setFillHeight = function(){
    var vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', vh+'px')
}
var setFillHeight_debounce = _.debounce(setFillHeight, 100)

// 画面のサイズ変動があった時に高さを再計算する
window.addEventListener('resize', setFillHeight_debounce)

// 初期化
setFillHeight()
